import _ from '@lodash';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, useMediaQuery } from '@mui/material';

import Icon from 'app/main/components/Icon';
import { setDefaultSettings } from 'app/store/fuse/settingsSlice';
import { navbarToggleMobile, navbarToggle } from '../../store/fuse/navbarSlice';

interface NavbarToggleButtonProps {
	className?: string;
	children?: React.ReactNode;
}

function NavbarToggleButton({ className, children = <Icon icon="menu" /> }: NavbarToggleButtonProps) {
	const dispatch = useDispatch();
	const isXlDown = useMediaQuery(theme => theme.breakpoints.down('xl'));

	const settings = useSelector(({ fuse }: any) => fuse.settings.current);
	const { config } = settings.layout;

	return (
		<IconButton
			className={className}
			onClick={ev =>
				dispatch(
					isXlDown
						? navbarToggleMobile()
						: config.navbar.style === 'style-2'
							? dispatch(
									setDefaultSettings(
										_.set({}, 'layout.config.navbar.folded', !settings.layout.config.navbar.folded)
									)
								)
							: navbarToggle()
				)
			}
			color="inherit"
			size="small"
		>
			{children}
		</IconButton>
	);
}

export default NavbarToggleButton;
